var map = {
	"./RCLOUDPHX_Loginpageimage.svg": 85252,
	"./RUNMYBOT_Loginpageimage.svg": 10131,
	"assetts/images/RCLOUDPHX_Loginpageimage.svg": 85252,
	"assetts/images/RUNMYBOT_Loginpageimage.svg": 10131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23566;